import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

export default function UseConditions() {
  return (
    <Container fluid className="p-4">
      <h1>TERMINI E CONDIZIONI D'USO</h1>
      <i>Ultimo aggiornamento: 24 Febbraio 2025</i>
      <p>
        Benvenuto su <strong>GetMove</strong>. Utilizzando la nostra
        applicazione mobile e i relativi servizi, accetti i seguenti Termini e
        Condizioni d’Uso. Ti invitiamo a leggere attentamente questo documento
        prima di utilizzare la piattaforma.
      </p>
      <ol>
        <li>
          <p>
            <strong>ACCETTAZIONE DEI TERMINI</strong>
          </p>
          <p>
            Utilizzando GetMove, dichiari di aver letto, compreso e accettato
            questi Termini e Condizioni d’Uso. Se non accetti i presenti
            termini, ti invitiamo a non utilizzare i nostri servizi.
          </p>
          <p>
            Ci riserviamo il diritto di aggiornare o modificare questi termini
            in qualsiasi momento. Eventuali modifiche saranno comunicate tramite
            l’applicazione o via email. L’uso continuato dei servizi dopo tali
            modifiche implica l’accettazione dei nuovi termini.
          </p>
        </li>
        <li>
          <p>
            <strong>REQUISITI PER L’UTILIZZO DEL SERVIZIO</strong>
          </p>
          <ul>
            <li>
              <p>
                Devi avere almeno 13 anni (o l’età minima richiesta dalla
                legislazione locale) per utilizzare GetMove.
              </p>
            </li>
            <li>
              <p>
                Se hai meno di 18 anni, devi avere il consenso di un genitore o
                tutore legale per accedere ai servizi.
              </p>
            </li>
            <li>
              <p>
                È vietato fornire informazioni false o impersonare un’altra
                persona.
              </p>
            </li>
          </ul>
          <li>
            <p>
              <strong>DESCRIZIONE DEL SERVIZIO</strong>
            </p>
            <p>GetMove è un'applicazione che consente agli utenti di:</p>
            <ul>
              <li>
                <p>Prenotare e gestire campi sportivi.</p>
              </li>
              <li>
                <p>
                  Partecipare a tornei e unirsi alle partite organizzate da
                  altri utenti.
                </p>
              </li>
              <li>
                <p>
                  Utilizzare la chat per comunicare con altri utenti della
                  piattaforma.
                </p>
              </li>
            </ul>
            <p>
              Ci riserviamo il diritto di modificare, sospendere o interrompere
              qualsiasi parte dei servizi in qualsiasi momento, senza obbligo di
              preavviso.
            </p>
          </li>
        </li>
        <li>
          <p>
            <strong>USO DELLA CHAT E COMPORTAMENTO DEGLI UTENTI</strong>
          </p>
          <p>
            Gli utenti di GetMove possono comunicare tra loro tramite la chat
            integrata. L’uso della chat è soggetto alle seguenti regole:
          </p>
          <ul>
            <li>
              <p>
                È vietato pubblicare contenuti offensivi, discriminatori, osceni
                o violenti.
              </p>
            </li>
            <li>
              <p>
                Non è consentito promuovere prodotti, servizi o attività
                illegali.
              </p>
            </li>
            <li>
              <p>
                Non è ammesso lo spam o l’invio ripetuto di messaggi
                indesiderati.
              </p>
            </li>
          </ul>
          <p>
            Ci riserviamo il diritto di monitorare la chat per garantire il
            rispetto delle regole. Gli utenti che violano ripetutamente queste
            regole possono essere sospesi o bannati permanentemente dalla
            piattaforma.
          </p>
        </li>
        <li>
          <p>
            <strong>ACCOUNT E SICUREZZA</strong>
          </p>
          <p>
            Gli utenti sono responsabili della sicurezza del proprio account e
            delle proprie credenziali di accesso.
          </p>
          <ul>
            <li>
              <p>
                Non condividere le credenziali di accesso con altre persone.
              </p>
            </li>
            <li>
              <p>
                Se sospetti un uso non autorizzato del tuo account, segnalalo
                immediatamente a support@getmoveapp.com.
              </p>
            </li>
            <li>
              <p>
                GetMove non sarà responsabile per eventuali danni derivanti
                dall’uso non autorizzato del tuo account.
              </p>
            </li>
          </ul>
          <p>
            Ci riserviamo il diritto di sospendere o eliminare un account se
            viene utilizzato in modo improprio o in violazione dei presenti
            Termini d’Uso.
          </p>
        </li>
        <li>
          <p>
            <strong>SOSPENSIONE E BAN DEGLI UTENTI</strong>
          </p>
          <p>
            Ci riserviamo il diritto di sospendere o bannare qualsiasi utente
            che violi questi Termini d'Uso, in particolare per:
          </p>
          <ul>
            <li>
              <p>Violazione delle regole della chat.</p>
            </li>
            <li>
              <p>Uso fraudolento o abusivo della piattaforma.</p>
            </li>
            <li>
              <p>Pubblicazione di contenuti inappropriati o illegali.</p>
            </li>
            <li>
              <p>Uso di strumenti automatizzati o tentativi di hacking.</p>
            </li>
          </ul>
          <p>
            Le sospensioni possono essere temporanee o permanenti, a seconda
            della gravità della violazione. Gli utenti possono contestare un ban
            contattando support@getmoveapp.com.
          </p>
        </li>
        <li>
          <p>
            <strong>PROPRIETÀ INTELLETTUALE</strong>
          </p>
          <p>
            Tutti i contenuti presenti su GetMove, inclusi testi, loghi, design,
            software e immagini, sono di proprietà esclusiva di GetMove srl o
            dei rispettivi proprietari.
          </p>
          <ul>
            <li>
              <p>
                Non è consentito copiare, distribuire o modificare i contenuti
                di GetMove senza autorizzazione.
              </p>
              <p>
                Gli utenti mantengono la proprietà dei contenuti che caricano
                sulla piattaforma, ma concedono a GetMove una licenza per
                utilizzarli ai fini della fornitura del servizio.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <strong>LIMITAZIONE DI RESPONSABILITÀ</strong>
          </p>
          <ul>
            <li>
              <p>
                <strong>Fornitura del servizio</strong>
              </p>
              <p>
                GetMove fornisce la piattaforma "così com'è" (as is) e "secondo
                disponibilità" (as available). Ci impegniamo a garantire il
                miglior funzionamento possibile del servizio, ma non garantiamo
                che l'app sia priva di errori, interruzioni o malfunzionamenti.
              </p>
            </li>
            <li>
              <p>
                <strong>
                  Esclusione di responsabilità per eventi fuori dal nostro
                  controllo
                </strong>
              </p>
              <p>
                GetMove non è responsabile per eventuali malfunzionamenti,
                sospensioni o limitazioni dell'accesso al servizio causati da:
              </p>
              <ul>
                <li>
                  <p>
                    Guasti tecnici non imputabili direttamente a noi (es.
                    problemi del server, errori di terze parti, attacchi
                    informatici).
                  </p>
                </li>
                <li>
                  <p>
                    Eventi di forza maggiore (es. terremoti, pandemie, blackout,
                    cyber-attacchi su larga scala).
                  </p>
                </li>
                <li>
                  <p>
                    Manutenzione programmata del sistema, di cui daremo
                    comunicazione agli utenti.
                  </p>
                </li>
              </ul>
            </li>
            <li>
              <p>
                <strong>
                  Responsabilità per i contenuti generati dagli utenti
                </strong>
              </p>
              <p>
                GetMove non è responsabile per i contenuti pubblicati dagli
                utenti sulla piattaforma, inclusi i messaggi nella chat.
                Tuttavia, ci riserviamo il diritto di rimuovere contenuti che
                violano i presenti Termini d'Uso o le leggi vigenti.
              </p>
            </li>
            <li>
              <p>
                <strong>Responsabilità dell'utente</strong>
              </p>
              <p>
                Responsabilità dell'utente L'utente è responsabile per il
                proprio utilizzo della piattaforma e si impegna a:
              </p>
              <ul>
                <li>
                  <p>
                    Non violare le leggi vigenti attraverso l’uso della
                    piattaforma.
                  </p>
                </li>
                <li>
                  <p>
                    Non pubblicare contenuti offensivi, illegali o dannosi per
                    altri utenti.
                  </p>
                </li>
                <li>
                  <p>
                    Non compromettere la sicurezza del proprio account o di
                    altri utenti.
                  </p>
                </li>
              </ul>
            </li>
            <li>
              <p>
                <strong>
                  Esclusione di responsabilità per danni indiretti
                </strong>
              </p>
              <p>
                Nei limiti consentiti dalla legge, GetMove non sarà responsabile
                per eventuali danni indiretti, incidentali o consequenziali
                derivanti dall'uso o dall'impossibilità di utilizzare l’app,
                inclusi:
              </p>
              <ul>
                <li>
                  <p>
                    Perdite di dati, profitti, opportunità o reputazione
                    commerciale.
                  </p>
                </li>
                <li>
                  <p>
                    Problemi derivanti da interazioni tra utenti sulla
                    piattaforma.
                  </p>
                </li>
              </ul>
            </li>
            <li>
              <p>
                <strong>Responsabilità per danni diretti</strong>
              </p>
              <p>
                Nei casi in cui la legge preveda una nostra responsabilità per
                danni diretti causati da negligenza grave o dolo, GetMove
                risponderà nei limiti previsti dalle normative applicabili.
                Tuttavia, nei limiti consentiti dalla legge, la nostra
                responsabilità complessiva non potrà superare l’importo
                eventualmente pagato dall’utente per l’uso del servizio nei sei
                (6) mesi precedenti l’evento che ha dato origine alla richiesta
                di risarcimento.
              </p>
            </li>
            <li>
              <p>
                <strong>Diritti dei consumatori</strong>
              </p>
              <p>
                Nulla di quanto contenuto in questi Termini d'Uso limita i
                diritti inderogabili degli utenti previsti dalla normativa sulla
                protezione dei consumatori, incluse le disposizioni del Codice
                del Consumo (D. Lgs. 206/2005) per gli utenti italiani.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <strong>CANCELLAZIONE DELL'ACCOUNT</strong>
          </p>
          <p>
            Gli utenti possono cancellare il proprio account in qualsiasi
            momento inviando una richiesta a support@getmoveapp.com.
          </p>
          <ul>
            <li>
              <p>
                Alcuni dati potrebbero essere conservati per motivi legali o di
                sicurezza.
              </p>
            </li>
            <li>
              <p>
                Se un account viene cancellato, l’utente perderà l’accesso a
                tutte le funzionalità di GetMove.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <strong>LEGGE APPLICABILE E RISOLUZIONE DELLE CONTROVERSIE</strong>
          </p>
          <p>Questi Termini d'Uso sono regolati dalla legge italiana.</p>
          <ul>
            <li>
              <p>Eventuali controversie verranno risolte in via amichevole.</p>
            </li>
            <li>
              <p>
                Se non è possibile trovare un accordo, la competenza spetta ai
                tribunali italiani.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            <strong>CONTATTI</strong>
          </p>
          <p>Per qualsiasi domanda o problema, puoi contattarci a:</p>
          <span>WebSite strategy di Giambrone Francesco</span>
          <br />
          <span>Corso Roma, 105</span>
          <br />
          <span>support@getmoveapp.com</span>
          <br />
          <span>Borgetto, PA 90042</span>
          <br />
          <span>Italy</span>
          <br />
        </li>
      </ol>
    </Container>
  );
}
